import React, { ReactNode } from 'react'
import InfoPanel from 'components/generic/InfoPanel'
import styles from './empty-watchlist-panel.module.scss'
import BtnPrimary from 'components/generic/BtnPrimary'
import i18n from 'constants/strings'

interface Props {
  title: string
  icon: ReactNode
  btnUrl: string
}

const EmptyWatchlistPanel = ({ icon, title, btnUrl }: Props) => {
  return (
    <InfoPanel
      as='article'
      icon={icon}
      title={title}
      info={
        <>
          <p>{i18n.t('strWatchlists.overview.panelEmpty.info')}</p>
          <BtnPrimary size='small' href={btnUrl}>
            {i18n.t('strWatchlists.overview.panelEmpty.button')}
          </BtnPrimary>
        </>
      }
      className={styles.infoPanel}
    />
  )
}

export default EmptyWatchlistPanel
